import React, { ChangeEvent } from "react";

interface Input {
  id: string;
  label: string;
  value: string | undefined;
  name: string;
  onChange: (name: string, value: string) => void;
  inputMode?: any;
}

const ShippingAddressInput: React.FC<Input> = ({ id, label, value, onChange, name, inputMode }) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(name, e.target.value);
  };

  return (
    <div className='form-floating'>
      <input
        type='text'
        name={name}
        className='form-control is-valid'
        id={name}
        value={value}
        onChange={handleChange}
        placeholder={name}
        inputMode={inputMode}
      />
      <label htmlFor={name}>{label}</label>
    </div>
  );
};

export default ShippingAddressInput;

export const emptyScheduleObject = {
  optionSelected: null,
  securitySchedule: {
    workDate: null,
    workTime: null,
    workTimeFriendly: null,
    asap: false,
    availableAppointments: [],
  },
  nonSecuritySchedule: {
    workDate: null,
    workTime: null,
    workTimeFriendly: null,
    asap: false,
  },
  installationTextNumber: "",
  shippingAddress: {
    streetNumber: null,
    streetName: null,
    apartmentNumber: null,
    city: null,
    state: null,
    zipCode: null,
  },
  billCycle: 2,
};
